// Reducer
import { ACTION_TYPES } from './corporate.actions';
import { CorporateState, initialState } from './corporate.state';
import update from 'immutability-helper';

export default (state: CorporateState = initialState, action): CorporateState => {
  switch (action.type) {
    case ACTION_TYPES.SET_SELECTED_OFFER: {
      return {
        ...state,
        selectedOffer: action.payload,
        hasFetchedOffer: true
      };
    }
    case ACTION_TYPES.INIT_HAS_FETCHED_OFFER: {
      return {
        ...state,
        hasFetchedOffer: false
      };
    }
    case ACTION_TYPES.OPEN_PAGE_MARKETING: {
      return {
        ...state,
        pageMarketing: action.payload.page
      };
    }

    case ACTION_TYPES.HIDE_PAGE_MARKETING: {
      return {
        ...state,
        pageMarketing: undefined
      };
    }

    case ACTION_TYPES.SET_DOC_URL: {
      return {
        ...state,
        docUrl: { ...state.docUrl, [action.payload.code]: action.payload.docUrl }
      };
    }
    case ACTION_TYPES.UPDATE_PAYMENT_ERROR: {
      return {
        ...state,
        paymentStatus: action?.payload?.status,
        paymentAuthorization: action?.payload?.authorization
      };
    }
    case ACTION_TYPES.SET_ERROR: {
      return {
        ...state,
        errorMessage: action.payload
      };
    }
    case ACTION_TYPES.INITIALIZE_INSUREDGOODS: {
      const { rules, inputTypes, cmsContent, insuredGoods } = action.payload;

      // TODO: revoir ce qui vient de prismic (camelCase) -> adapter le module à ça
      const insuredGoodsEntities = {};
      (cmsContent['insured_goods_entities'] as any[]).forEach(entitie => {
        insuredGoodsEntities[entitie.code.value] = entitie.label.value;
      });

      const _cmsContent = {
        excludingTaxes: cmsContent['excluding_taxes'],
        includingTaxes: cmsContent['including_taxes'],
        total: cmsContent['total'],
        insuredGoodsEntities
      };

      return {
        ...state,
        products: { insuredGoods, rules, inputTypes, cmsContent: _cmsContent, isReady: true }
      };
    }
    case ACTION_TYPES.UPDATE_INSUREDGOOD: {
      const newArray = [...state.products.insuredGoods];
      newArray[action.payload.index] = action.payload.elementGood;

      return {
        ...state,
        products: { ...state.products, insuredGoods: newArray }
      };
    }
    case ACTION_TYPES.UPDATE_INSUREDGOOD_AMOUNT: {
      return update(state, {
        products: {
          insuredGoods: {
            [action.payload.index]: {
              purchasePrice: {
                amount: {
                  $set: action.payload.amount
                }
              }
            }
          }
        }
      });
    }
    case ACTION_TYPES.UPDATE_INSUREDGOODS_PURCHASE_DATE: {
      return {
        ...state,
        products: { ...state.products, insuredGoods: action.payload }
      };
    }
    case ACTION_TYPES.SET_EMAIL_SENDED: {
      return {
        ...state,
        emailSended: true
      };
    }
    default:
      return state;
  }
};
